<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--single-or-double">
    @if (osResponses.length) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <div class="monitor_circle-box">
          {{ 'correctAnswers' | translate }}:
          <br><br>
          <span class="text--xxl">
            <span>{{getCorrect('OS')}}</span>&nbsp;&#47;&nbsp;<span>{{getAnswered('OS')}}</span>
          </span>
        </div>
      </div>
    }
    @if (odResponses.length) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <div class="monitor_circle-box">
          {{ 'correctAnswers' | translate }}:
          <br><br>
          <span class="text--xxl">
            <span>{{getCorrect('OD')}}</span>&nbsp;&#47;&nbsp;<span>{{getAnswered('OD')}}</span>
          </span>
        </div>
      </div>
    }
    @if (ouResponses.length) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_circle-box">
          {{ 'correctAnswers' | translate }}:
          <br><br>
          <span class="text--xxl">
            <span>{{getCorrect('OU')}}</span>&nbsp;&#47;&nbsp;<span>{{getAnswered('OU')}}</span>
          </span>
        </div>
      </div>
    }
  </div>

  <div class="monitor_container-column">
    @if (osResponses.length) {
      <div class="monitor_graph-box">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <app-percentage-circle
          id="test-percentage-left"
          class="monitor_circle-box"
          [percentage]="getPercentageDone(osResponses)">
        </app-percentage-circle>
      </div>
    }
    @if (odResponses.length) {
      <div class="monitor_graph-box">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <app-percentage-circle
          id="test-percentage-right"
          class="monitor_circle-box"
          [percentage]="getPercentageDone(odResponses)">
        </app-percentage-circle>
      </div>
    }
    @if (ouResponses.length) {
      <div class="monitor_graph-box">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <app-percentage-circle
          id="test-percentage-both"
          class="monitor_circle-box"
          [percentage]="getPercentageDone(ouResponses)">
        </app-percentage-circle>
      </div>
    }
  </div>
</app-monitor-layout>
